

export class CertValidator {
    _issuer: any;
    _serial: any;

	constructor(issuer, serial) {
		if (typeof issuer !== 'string' || typeof serial !== 'string') throw new TypeError('Arguments must be string');
		this._issuer = this.toMap(issuer);
		this._serial = serial.toLowerCase();
	}
	match(aIssuer, aSerial) {
		if (this._serial !== aSerial.toLowerCase()) return false;
		let other = this.toMap(aIssuer);
		if (other.size !== this._issuer.size) return false;
		this._issuer.forEach((value, key) => {
			if (other.has(key)) {
				let content = other.get(key);
				if (content && content.toLowerCase() === value.toLowerCase()) other.delete(key);
			}
		});
		return other.size === 0;
	}
	getFieldFromDN(field) {
		let ret = '';
		let has = this._issuer.get(field.toLowerCase());
		if (has) ret = has;
		return ret;
	}
	toMap(dn) {
		let map = new Map();
		let parts = dn.split(/\,|\;/);
		parts.forEach(item => {
			let parts = item.split('=');
			let key = parts[0].toLowerCase().trim();
			let value = parts.length === 2 ? parts[1].trim() : '';
			map.set(key, value);
		});
		return map;
	}
}

